module.exports = __webpack_public_path__ + "media/images/mail-header-aa237422373b949f7de3122287836925.jpg";